import { useMemo } from 'react';
 
/**
 * Compatibility shim for existing dropdown call sites. Options must provide a
 * stable `{ value, label }`; the visible label never changes with UI language.
 * Field labels, helper text, validation, and accessibility copy still use i18n.
 */
export default function useTranslatedOptions(options) {
  return useMemo(
    () => options.map(option => ({
      value: option.value,
      label: option.label || String(option.value),
    })),
    [options],
  );
}
